import { TestCard } from "./test";
export function TestGrid({ tests, level,Upgradetoggle }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {tests.map((test) => (
        <TestCard
          key={test.id}
          testNumber={test.id}
          isPremium={test.is_premium}
          progress={test.progress_score}
          level={level}
          skill={test.test_title}
          status={test.status}
          assignmentId={test.assignment_id}
          testId={test.assessment_id}
          Upgradetoggle={Upgradetoggle}
        />
      ))}
    </div>
  );
}

